//used for SEO

export const assetContentMapping = {
  '0-0-1z5148987': {
    title: 'RRR ஃபுல் ஹெச்டி திரைப்படத்தை ஆன்லைனில் ZEE5ல் காணுங்கள்',
    description:
      '1920 ஆம் ஆண்டு, வீட்டிலிருந்து பிரிந்து ஆங்கிலேய அரசுக்கு எதிராக தங்களது தனிப்பட்ட ' +
      'குறிக்கோள்களுக்காக போராடும் இரு கிளர்ச்சியாளர்களை விதி ஒன்று சேர்க்கிறது.'
  },
  '0-0-1z5148988': {
    title: 'ಫುಲ್ HDಯಲ್ಲಿ RRR ಚಲನಚಿತ್ರವನ್ನು ಆನ್‌ಲೈನ್‌ನಲ್ಲಿ ವೀಕ್ಷಿಸಿ ZEE5 ನಲ್ಲಿ',
    description:
      '1920 ರಲ್ಲಿ, ತಮ್ಮ ವೈಯಕ್ತಿಕ ಉದ್ದೇಶಗಳಿಗಾಗಿ ಬ್ರಿಟಿಷ್ ಸಾಮ್ರಾಜ್ಯದ ವಿರುದ್ಧ ಹೋರಾಡುತ್ತಿರುವ ' +
      'ಕ್ರಾಂತಿಕಾರಿಗಳಾದ ರಾಮ್ ಮತ್ತು ಭೀಮ್ ಅವರನ್ನು ವಿಧಿಯು ಒಂದಾಗಿಸುತ್ತದೆ.'
  },
  '0-0-1z5148989': {
    title: 'ഓൺലൈനായി കാണൂ RRR, HD ദൃശ്യമികവിൽ നിങ്ങളുടെ ZEE5-ൽ!',
    description:
      'ബ്രിട്ടീഷ് സാമ്രാജ്യത്തിനെതിരെ കലാപത്തിനിറങ്ങിയ അല്ലൂരി സീതാരാമ രാജു, ' +
      'കോമരം ഭീം എന്നി സ്വാതന്ത്ര്യ സമരസേനാനികളുടെ ഇതിഹാസ കഥ!'
  }
};

export const kashmirFilesMovieIds = [
  '0-0-1z5141112',
  '0-0-1z5133458',
  '0-0-1z5141241',
  '0-0-1z5141243'
];

export const kashmirFilesGlobalUrlMapping = {
  '0-0-1z5141112': [
    'https://www.zee5.com/global/movies/details/the-kashmir-files-kannada/0-0-1z5141112',
    'kn-in'
  ],
  '0-0-1z5141241': [
    'https://www.zee5.com/global/movies/details/the-kashmir-files-tamil/0-0-1z5141241',
    'ta-in'
  ],
  '0-0-1z5141243': [
    'https://www.zee5.com/global/movies/details/the-kashmir-files-telugu/0-0-1z5141243',
    'te-in'
  ],
  '0-0-1z5133458': [
    'https://www.zee5.com/global/movies/details/the-kashmir-files/0-0-1z5133458',
    'hi-in'
  ]
};

export const kashmirFilesUrlMapping = {
  '0-0-1z5141112': [
    'https://www.zee5.com/movies/details/the-kashmir-files-kannada/0-0-1z5141112',
    'kn-in'
  ],
  '0-0-1z5141241': [
    'https://www.zee5.com/movies/details/the-kashmir-files-tamil/0-0-1z5141241',
    'ta-in'
  ],
  '0-0-1z5141243': [
    'https://www.zee5.com/movies/details/the-kashmir-files-telugu/0-0-1z5141243',
    'te-in'
  ],
  '0-0-1z5133458': [
    'https://www.zee5.com/movies/details/the-kashmir-files/0-0-1z5133458',
    'hi-in'
  ]
};

export const karthikeyaMovieIds = [
  '0-0-1z5227557',
  '0-0-1z5227565',
  '0-0-1z5227563'
];

export const karthikeyaGlobalUrlMapping = {
  '0-0-1z5227565': [
    'https://www.zee5.com/global/movies/details/karthikeya-2/0-0-1z5227565',
    'hi'
  ],
  '0-0-1z5227563': [
    'https://www.zee5.com/global/movies/details/karthikeya-2/0-0-1z5227563',
    'ta'
  ]
};

export const karthikeyaUrlMapping = {
  '0-0-1z5227557': [
    'https://www.zee5.com/movies/details/karthikeya-2/0-0-1z5227557',
    'en-in'
  ],
  '0-0-1z5227565': [
    'https://www.zee5.com/movies/details/karthikeya-2/0-0-1z5227565',
    'hi-in'
  ],
  '0-0-1z5227563': [
    'https://www.zee5.com/movies/details/karthikeya-2/0-0-1z5227563',
    'ta-in'
  ]
};

export const rrrMovieIds = [
  '0-0-1z5145092',
  '0-0-1z5148989',
  '0-0-1z5148988',
  '0-0-1z5148987'
];

export const rrrGlobalUrlMapping = {
  '0-0-1z5148989': [
    'https://www.zee5.com/global/movies/details/rrr-malayalam/0-0-1z5148989',
    'ml'
  ],
  '0-0-1z5148988': [
    'https://www.zee5.com/global/movies/details/rrr-kannada/0-0-1z5148988',
    'kn'
  ],
  '0-0-1z5148987': [
    'https://www.zee5.com/global/movies/details/rrr-tamil/0-0-1z5148987',
    'ta'
  ]
};

export const rrrUrlMapping = {
  '0-0-1z5145092': [
    'https://www.zee5.com/movies/details/rrr/0-0-1z5145092',
    'en-in'
  ],
  '0-0-1z5148989': [
    'https://www.zee5.com/movies/details/rrr-malayalam/0-0-1z5148989',
    'ml-in'
  ],
  '0-0-1z5148987': [
    'https://www.zee5.com/movies/details/rrr-tamil/0-0-1z5148987',
    'ta-in'
  ],
  '0-0-1z5148988': [
    'https://www.zee5.com/movies/details/rrr-kannada/0-0-1z5148988',
    'kn-in'
  ]
};

export const KARTHIKEYA_CANONICAL_GLOBAL_URL =
  'https://www.zee5.com/global/movies/details/karthikeya-2/0-0-1z5227557';

export const KARTHIKEYA_CANONICAL_URL =
  'https://www.zee5.com/movies/details/karthikeya-2/0-0-1z5227557';

export const RRR_CANONICAL_URL =
  'https://www.zee5.com/movies/details/rrr/0-0-1z5145092';

export const rangbaazWebSeriesIds = [
  '0-6-4z5173774',
  '0-6-4z5176942',
  '0-6-4z5176940'
];

export const gadarMovieID = '0-0-1z5375877';
export const gadar2MovieID = '0-0-1z5437988';
export const ghoomerMovieId = '0-0-1z5454041';
export const kadakSinghMovieId = '0-0-1z5469034';
export const tejasMovieId = '0-0-1z5489618';
export const samBahadurMovieId = '0-0-1z5500337';
export const Khichdi2MovieId = '0-0-1z5500000';
export const theKeralaStoryMovieId = '0-0-1z5512788';
export const mainAtalHoonMovieId = '0-0-1z5528544';

export const rangbaazDubbedPageIds = ['0-6-4z5176942', '0-6-4z5176940'];

export const rangbaazOldWebSeriesIds = ['0-6-1322', '0-6-1320', '0-6-1138'];

export const rangbaazGlobalUrlMapping = {
  '0-6-4z5176942': [
    'https://www.zee5.com/global/web-series/details/rangbaaz-darr-ki-rajneeti-telugu/0-6-4z5176942',
    'te'
  ],
  '0-6-4z5176940': [
    'https://www.zee5.com/global/web-series/details/rangbaaz-darr-ki-rajneeti-tamil/0-6-4z5176940',
    'ta'
  ]
};

export const rangbaazUrlMapping = {
  '0-6-4z5173774': [
    'https://www.zee5.com/web-series/details/rangbaaz-darr-ki-rajneeti/0-6-4z5173774',
    'en-in'
  ],
  '0-6-4z5176942': [
    'https://www.zee5.com/web-series/details/rangbaaz-darr-ki-rajneeti-telugu/0-6-4z5176942',
    'te-in'
  ],
  '0-6-4z5176940': [
    'https://www.zee5.com/web-series/details/rangbaaz-darr-ki-rajneeti-tamil/0-6-4z5176940',
    'ta-in'
  ]
};

export const RANGBAAZ_CANONICAL_URL =
  'https://www.zee5.com/web-series/details/rangbaaz-darr-ki-rajneeti/0-6-4z5173774';

export const RANGBAAZ_CANONICAL_GLOBAL_URL =
  'https://www.zee5.com/global/web-series/details/rangbaaz-darr-ki-rajneeti/0-6-4z5173774';

export const RAKSHA_BANDHAN_CANONICAL_URL =
  'https://www.zee5.com/movies/details/raksha-bandhan/0-0-1z5228525';

export const RAKSHA_BANDHAN_CANONICAL_GLOBAL_URL =
  'https://www.zee5.com/global/movies/details/raksha-bandhan/0-0-1z5228525';

export const GADAR_CANONICAL_URL =
  'https://www.zee5.com/movies/details/gadar-ek-prem-katha/0-0-gadarekpremkatha';

export const rakshaBandhanCollectionIds = [
  '0-8-3z5197941',
  '0-8-8486',
  '0-8-manualcoll_938761592'
];

export const X_DEFAULT_HREF_LANG = {
  GLOBAL: {
    KASHMIR_FILES:
      'https://www.zee5.com/global/movies/details/the-kashmir-files/0-0-1z5141112',
    KARTHIKEYA:
      'https://www.zee5.com/global/movies/details/karthikeya-2/0-0-1z5227557',
    RRR: 'https://www.zee5.com/global/movies/details/rrr/0-0-1z5145092',
    RANGBAAZ:
      'https://www.zee5.com/global/web-series/details/rangbaaz-darr-ki-rajneeti/0-6-4z5173774'
  },
  INDIA: {
    KASHMIR_FILES:
      'https://www.zee5.com/movies/details/the-kashmir-files/0-0-1z5141112'
  }
};
